// extracted by mini-css-extract-plugin
module.exports = {"articles":"EduHubPage_articles__tZl4m","grid":"EduHubPage_grid__NtRmw","slide-in-out":"EduHubPage_slide-in-out__yOyu_","fade-in-out":"EduHubPage_fade-in-out__1q8Qd"};